import React, { ReactNode, useContext } from 'react';
import { Row, Col } from 'antd';
import { ConfigContext } from '../../context/Config';
import CardContainer from '../CardContainer';
import Wrapper from '../Wrapper';
import isEmpty from 'lodash/isEmpty';
import Text from '../Text';

export type ScheduleViewerCardProps = {
  title?: string | ReactNode;
  data?: Array<{
    weekDay: string;
    start: string;
    end: string;
  }>;
  isFlexible?: boolean;
};

const TScheduleViewerCard: React.FC<ScheduleViewerCardProps> = ({
  title,
  data,
  isFlexible,
}) => {
  const { translate } = useContext(ConfigContext);

  const props: { [key: string]: any } = {};
  if (!isEmpty(data)) {
    props.mb = 1;
  }

  return (
    <CardContainer shadow={false}>
      <Wrapper {...props}>{title}</Wrapper>
      {!!isFlexible && (
        <Wrapper pt={3} pl={3}>
          <Text rows={1} level={3}>
            {translate('ui.flexible.schedule')}
          </Text>
        </Wrapper>
      )}
      {!isEmpty(data) && (
        <Row gutter={[8, 8]}>
          {data.map((item, index) => (
            <Col span={12} key={index}>
              <Text bold level={3} rows={1}>
                {translate(item.weekDay)}
              </Text>
              <Text level={3} rows={1}>
                {item.start} - {item.end}
              </Text>
            </Col>
          ))}
        </Row>
      )}
    </CardContainer>
  );
};

export default TScheduleViewerCard;
